import { useNavigate } from 'react-router-dom'
import Button from 'react-bootstrap/Button'

function NavigateToButton({ children, variant = 'primary', size = 'sm', to }) {
  const navigate = useNavigate()

  return (
    <Button size={size} variant={variant} onClick={() => navigate(to)}>
      {children}
    </Button>
  )
}

export default NavigateToButton
